/**
 * Lockstep Platform SDK for TypeScript
 *
 * (c) 2021-2023 Lockstep, Inc.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 *
 * @author     Lockstep Network <support@lockstep.io>
 * @copyright  2021-2023 Lockstep, Inc.
 * @link       https://github.com/Lockstep-Network/lockstep-sdk-typescript
 */
export class FinancialAccountClient {
    /**
     * Internal constructor for this client library
     */
    constructor(client) {
        this.client = client;
    }
    /**
     * Creates a financial account with the specified name.
     *
     * @param body Metadata about the financial account to create.
     */
    createFinancialAccount(body) {
        const url = `/api/v1/FinancialAccount`;
        return this.client.request("post", url, null, body);
    }
    /**
     * Retrieves the financial account specified by this unique identifier.
     *
     * @param id The unique Lockstep Platform ID number of this Account; NOT the customer's ERP key
     */
    retrieveFinancialAccount(id) {
        const url = `/api/v1/FinancialAccount/${id}`;
        return this.client.request("get", url, null, null);
    }
    /**
     *
     * @param id The unique Lockstep Platform ID number of the Account to update; NOT the customer's ERP key
     * @param body A list of changes to apply to this Account
     */
    updateFinancialAccount(id, body) {
        const url = `/api/v1/FinancialAccount/${id}`;
        return this.client.request("patch", url, null, body);
    }
    /**
     * Deletes the Financial Account referred to by this unique identifier.
     *
     * @param id The unique Lockstep Platform ID number of the Financial Account to disable; NOT the customer's ERP key
     */
    deleteFinancialAccount(id) {
        const url = `/api/v1/FinancialAccount/${id}`;
        return this.client.request("delete", url, null, null);
    }
    /**
     *
     * @param filter The filter for this query. See [Searchlight Query Language](https://developer.lockstep.io/docs/querying-with-searchlight)
     * @param include To fetch additional data on this object, specify the list of elements to retrieve.
     * @param order The sort order for this query. See See [Searchlight Query Language](https://developer.lockstep.io/docs/querying-with-searchlight)
     * @param pageSize The page size for results (default 250, maximum of 500). See [Searchlight Query Language](https://developer.lockstep.io/docs/querying-with-searchlight)
     * @param pageNumber The page number for results (default 0). See [Searchlight Query Language](https://developer.lockstep.io/docs/querying-with-searchlight)
     */
    queryFinancialAccounts(filter, include, order, pageSize, pageNumber) {
        const url = `/api/v1/FinancialAccount/query`;
        const options = {
            params: {
                filter,
                include,
                order,
                pageSize,
                pageNumber,
            },
        };
        return this.client.request("get", url, options, null);
    }
}
//# sourceMappingURL=FinancialAccountClient.js.map